import { css } from '@emotion/css'
import { spacing, fontSize, shorthandHelper, colors, hexToRgba } from '@offerzen/pinata-shame'

const styles = {
  link: css({
    textDecoration: 'none',
    display: 'flex',
    alignItems: 'center',
    color: hexToRgba(colors.white, 0.6),
    padding: spacing.medium,
    borderRight: '4px solid transparent',
    transition: 'color 0.2s',

    '& svg': {
      fill: hexToRgba(colors.white, 0.6),
    },

    '&:hover': {
      color: colors.white,

      '& svg': {
        fill: colors.white,
      },
    },

    '&:focus': {
      outline: 'none',
      color: colors.white,

      '& svg': {
        fill: colors.white,
      },
    },
  }),

  activeLink: css({
    backgroundColor: colors.blueZodiac,
    borderRight: `4px solid ${colors.cornflowerBlue}`,
    color: colors.white,

    '& svg': {
      fill: colors.white,
    },
  }),

  subLink: css({
    textDecoration: 'none',
    display: 'flex',
    alignItems: 'center',
    color: hexToRgba(colors.white, 0.6),
    padding: shorthandHelper([spacing.default, spacing.large * 2]),
    borderRight: '4px solid transparent',
    fontSize: fontSize.small,
    transition: 'color 0.2s',

    '&:hover': {
      color: colors.white,
    },

    '&:focus': {
      outline: 'none',
      color: colors.white,
    },
  }),

  activeSubLink: css({
    borderRight: `4px solid ${colors.cornflowerBlue}`,
    color: colors.white,
  }),

  activeSubNav: css({
    '&::before': {
      content: '""',
      backgroundColor: colors.blueZodiac,
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
    },

    '& > *': {
      position: 'relative',
    },
  }),
}

export default styles
